export default "__VITE_ASSET__P3pcHYHP__"